<template>
  <div v-if="tagDefs.length" class="intake-tag-bar">
    <span class="intake-tag-bar__label">
      <v-icon size="14">mdi-tag-outline</v-icon>
      Tags
    </span>
    <TagChips :tags="tags" :tag-defs="tagDefs" size="md" />
    <TagPicker :tags="tags" :tag-defs="tagDefs" size="md" @update:tags="onTagsChanged" />
  </div>
</template>

<script setup>
import TagChips from "@/components/dashboard/TagChips.vue";
import TagPicker from "@/components/dashboard/TagPicker.vue";
import { intakeService } from "@/services/intakeService";
import { orderInfoService } from "@/services/orderInfoService";

const props = defineProps({
  tags: { type: Array, default: () => [] },
  tagDefs: { type: Array, default: () => [] },
  entityType: { type: String, required: true, validator: (v) => ["document", "order", "submission"].includes(v) },
  entityId: { type: [String, Number], required: true },
});

const emit = defineEmits(["update:tags"]);

async function onTagsChanged(newTags) {
  const oldTags = [...props.tags];
  emit("update:tags", newTags);
  try {
    if (props.entityType === "submission") {
      await orderInfoService.updateSubmissionTags(props.entityId, newTags);
    } else if (props.entityType === "document") {
      await intakeService.updateDocumentTags(props.entityId, newTags);
    } else {
      await intakeService.updateOrderTags(props.entityId, newTags);
    }
  } catch {
    emit("update:tags", oldTags);
  }
}
</script>

<style lang="scss" scoped>
.intake-tag-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 2px;
}

.intake-tag-bar__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: $lh_font_family_dm_sans;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: $lh_color_blue_gray;
  white-space: nowrap;
}
</style>
